import React from "react";
import "./header.scss";
import { scrollTo } from "../../service/scroll";

export default () => (
  <section className="hero" id="video" aria-labelledby="hero-title">
    <div className="hero-inner site-width">
      <div className="hero-copy">
        <p className="eyebrow"><span className="status-dot" /> Independent software consultant</p>
        <h1 id="hero-title">Thoughtful software.<br /><em>Built to last.</em></h1>
        <p className="hero-lede">I’m Tobias Klock. I help teams turn complex product ideas into clear, reliable web experiences—specializing in React, frontend architecture, and full-stack delivery.</p>
        <div className="hero-actions">
          <button className="button-primary" onClick={() => scrollTo("#portfolio")}>Explore my work <span aria-hidden="true">↗</span></button>
          <a className="button-secondary" href="mailto:TobiasKlock84@gmail.com">Get in touch <span aria-hidden="true">→</span></a>
        </div>
        <div className="hero-proof"><strong>12 years</strong><span>industry experience</span><i aria-hidden="true" /><strong>6 projects</strong><span>featured below</span></div>
      </div>
      <div className="hero-visual" aria-hidden="true">
        <div className="visual-frame"><div className="visual-grid" /><div className="visual-orbit visual-orbit-one" /><div className="visual-orbit visual-orbit-two" /><span className="visual-mark">TK<span>.</span></span><span className="visual-caption">CLARITY IN COMPLEXITY — SINCE 2014</span></div>
      </div>
    </div>
    <div className="hero-bottom site-width"><span>SCROLL TO EXPLORE</span><span aria-hidden="true">↓</span></div>
  </section>
);
